import { getRuntimeConfig } from "./config";

export const getBasePath = (): string => {
  const rawBasePath = getRuntimeConfig<string>(
    "BASE_PATH",
    "REACT_APP_BASE_PATH",
    ""
  );

  if (!rawBasePath || rawBasePath.trim() === "") {
    return "/";
  }

  let normalized = rawBasePath.trim();
  if (!normalized.startsWith("/")) {
    normalized = `/${normalized}`;
  }
  if (!normalized.endsWith("/")) {
    normalized = `${normalized}/`;
  }

  return normalized;
};

export const getBasePathWithoutTrailingSlash = (): string => {
  const basePath = getBasePath();
  return basePath === "/" ? "" : basePath.slice(0, -1);
};

